
import Vue from 'vue'
import axios from 'axios'
import { Prop, Component } from 'vue-property-decorator'
import { Job, TranslationActivity } from '../../global/models'
import { TranslationMarkup } from '../../global/models/translation-markup.model'
import DownloadTranslationModal from './DownloadTranslationModal.vue'
import TranslationSourceModal from './TranslationSourceModal.vue'

@Component({
  components: { DownloadTranslationModal, TranslationSourceModal }
})
export default class TranslationActivityView extends Vue {
  @Prop({ type: Object, required: true })
  readonly activity!: TranslationActivity

  @Prop({ type: Object, required: true })
  readonly job!: Job

  markups: TranslationMarkup[] = []

  get isCustomerTranslation() {
    return this.activity.documentType === 'customer-template'
  }

  get canViewAdditionalFields () {
    return this.job.type === 'customer' && this.isCustomerTranslation
  }

  get hideTable () {
    return this.job.status === 'draft' && this.activity.documentType === 'provider-template'
  }

  get translatorFields() {
    return this.markups.filter(i => !i.isCustomerProvided)
  }

  get regularFields() {
    return this.markups.filter(i => i.isCustomerProvided)
  }

  get downloadTranslationModal() {
    return this.$refs.downloadTranslationModal as DownloadTranslationModal
  }

  get sourceModal() {
    return this.$refs.sourceModal as TranslationSourceModal
  }

  mounted() {
    this.getData()
  }

  async getData() {
    const response = await axios.get<TranslationMarkup[]>(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/markups`)
    this.markups = response.data
  }

  viewDocument() {
    this.sourceModal.open(this.activity)
  }

  clickedDownloadTranslation() {
    this.downloadTranslationModal.open(this.activity)
  }
}
